
import { Component, Mixins } from "vue-property-decorator";
import { CopyLinkedCheckBehavior } from "../../../../../../documaker/domain/format/objects";
import { ICopyLinkedCheckBehaviorPropertyEditable, instanceOfICopyLinkedCheckBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class CopyLinkedCheckBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICopyLinkedCheckBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICopyLinkedCheckBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isCopyLinkedCheckBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICopyLinkedCheckBehaviorPropertyEditable(s) && s.copyLinkedCheckBehavior().isEditable(), false);
  }

  get copyLinkedCheckBehavior(): CopyLinkedCheckBehavior {
    return this.readPropertyOrDefault(s => CopyLinkedCheckBehavior.from(s.copyLinkedCheckBehavior().getValue()), new CopyLinkedCheckBehavior(false, 1));
  }

  set copyLinkedCheckBehavior(value: CopyLinkedCheckBehavior) {
    this.writePropertyWhenValid(s => s.copyLinkedCheckBehavior().setValue(CopyLinkedCheckBehavior.to(value)));
  }
}
